import { Paper, Skeleton, Stack } from "@mui/material";
import Grid from "@mui/material/Grid2";

export default function PerformanceSkeleton() {
  return (
    <Stack spacing={2.5}>
      <Skeleton variant="rounded" height={72} />

      <Grid container spacing={2.5}>
        {Array.from({ length: 4 }).map((_, index) => (
          <Grid size={{ xs: 12, sm: 6, md: 3 }} key={index}>
            <Paper variant="outlined" sx={{ p: 2 }}>
              <Skeleton variant="text" width="50%" />
              <Skeleton variant="text" width="70%" height={36} />
              <Skeleton variant="text" width="90%" />
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Grid container spacing={2.5}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Skeleton variant="rounded" height={270} />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Skeleton variant="rounded" height={270} />
        </Grid>
      </Grid>

      <Skeleton variant="rounded" height={320} />
    </Stack>
  );
}
